import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { hotelCollabs } from '../collabdata';
import './HotelCollabs.css';

export default function HotelCollaborations() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="collab-page-wrapper">
      <header className="collab-header-main">
        <span className="location-label">Our Global Portoflio</span>
        <h1 className="title-premium">Hotel Collaborations</h1>
        <p className="subtitle-premium">
          We partner with the world’s most prestigious properties to create authentic visual narratives and luxury travel experiences.
        </p>
      </header>

      <div className="collab-grid-premium">
        {hotelCollabs.map((hotel) => (
          <div 
            key={hotel.id} 
            className="card-premium"
            onClick={() => navigate(`/collaborations/${hotel.id}`)}
          >
            <div className="image-container">
              <img src={hotel.image} alt={hotel.name} />
              <div className="status-badge">{hotel.status}</div>
            </div>
            <div className="info-container">
              <span className="location-label">{hotel.location}</span>
              <h3 className="hotel-name-label">{hotel.name}</h3>
              <p className="desc-label">{hotel.description}</p>
              <button className="btn-premium-outline">Explore Partnership</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}